export const inclusionHasPackage = (inclusion, packageId: string) => {
  if (inclusion.packages.length === 0) {
    return false;
  }

  return inclusion.packages.some((packageItem) => packageItem.package_id === packageId);
};
